import moment, { Moment } from 'moment';

export const getMomentFromTime = (time) => {
  const quotient = Math.floor(time / 60);
  const remainder = time % 60;

  return moment()
    .hour(quotient - 1)
    .minute(remainder);
};

export const getTimeFromMoment = (time: Moment) => {
  return (time.hour() + 1) * 60 + time.minute();
};

export const weekdayLabels = {
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
};
